// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyA_Wz2uE-2dOelQEk_ojNnJIv_8nwTf8Lw",
//   authDomain: "flashpe-web.firebaseapp.com",
//   databaseURL: "https://flashpe-web-default-rtdb.firebaseio.com",
//   projectId: "flashpe-web",
//   storageBucket: "flashpe-web.appspot.com",
//   messagingSenderId: "439724571069",
//   appId: "1:439724571069:web:9dbce226a5efd1ee667ad4",
//   measurementId: "G-KXGED8H6DK"
// };

const firebaseConfig = {
  apiKey: "AIzaSyBUNATZfl4baQOSkHb3wTnvD6WSE8iNpWk",
  authDomain: "thediningapp-a976c.firebaseapp.com",
  databaseURL: "https://thediningapp-a976c.firebaseio.com",
  projectId: "thediningapp-a976c",
  storageBucket: "thediningapp-a976c.appspot.com",
  messagingSenderId: "248003873622",
  appId: "1:248003873622:web:826473ae1e0f2e531fe4f7",
  measurementId: "G-5HQYDNJL62",
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
export const firestoreDB = getFirestore(app);
export const auth = getAuth(app);
const functions = getFunctions(app);

// Connect to emulator in development
if (
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1"
) {
  console.log("🔧 Connecting to Firebase Functions Emulator on localhost:5001");
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
}

export { functions };
